import Markdown from '@ui-components-3/ui/lib/components/Markdown'
import capitalize from 'lodash/capitalize'
import Provider from 'models/Provider'
import { ReactNode } from 'react'

export type RowItem = {
  label: string
  value?: string | number
  tooltip?: string | Record<string, string>
  testId?: string
  renderValue?: (value?: string | number) => ReactNode
  hidden?: boolean
}

export const getProviderGeneralRows = (provider: Provider) => {
  if (!provider) {
    return []
  }

  const {
    // TODO - fix email type
    // @ts-ignore
    email,
    formattedAddress,
    phone,
    phoneType,
    smsNotificationStatus,
    emailNotificationStatus,
  } = provider

  const rows: RowItem[] = [
    { label: 'Email', value: email },
    { label: 'Physical address', value: formattedAddress },
    { label: 'Phone number', value: phone },
    { label: 'Phone Type', value: capitalize(phoneType) },
    { label: 'SMS Notifications', value: smsNotificationStatus },
    { label: 'Email Notifications', value: emailNotificationStatus },
  ]

  return rows.filter((i) => !i.hidden)
}

export const getProviderProfileRows = (provider: Provider) => {
  if (!provider) {
    return []
  }

  const {
    showDiagnosticExpertiseFieldInAccounts,
    showCommunityExpertiseFieldInAccounts,
    showReligiousExpertiseFieldInAccounts,
    parsedProfile,
  } = provider

  const {
    pronouns,
    raceEthnicity,
    genderIdentity,
    licenses,
    languages,
    diagnosticExpertise,
    communityExpertise,
    religiousExpertise,
    aboutMe,
    bestPartSuccessCoach,
    collegeSuccessTips,
    almaMater,
    firstNamePreferred,
  } = parsedProfile

  const hiddenIsSuccessCoach = (value) => provider.isSuccessCoachProvider || value

  const rows: RowItem[] = [
    { label: 'Preferred Name', value: firstNamePreferred },
    { label: 'Pronouns', value: pronouns },
    { label: 'Race & Ethnicity', value: raceEthnicity },
    { label: 'Gender Identity', value: genderIdentity },
    { label: 'Languages', value: languages },
    { label: 'Licenses', value: licenses, hidden: hiddenIsSuccessCoach(false) },
    {
      label: 'Diagnostic Expertise',
      value: diagnosticExpertise,
      hidden: hiddenIsSuccessCoach(!showDiagnosticExpertiseFieldInAccounts),
    },
    {
      label: 'Community Expertise',
      value: communityExpertise,
      hidden: hiddenIsSuccessCoach(!showCommunityExpertiseFieldInAccounts),
    },
    {
      label: 'Religious & Spiritual Expertise',
      value: religiousExpertise,
      hidden: hiddenIsSuccessCoach(!showReligiousExpertiseFieldInAccounts),
    },
    {
      label: 'About Me',
      value: aboutMe,
      renderValue: aboutMe ? (value) => <Markdown content={String(value)} /> : undefined,
    },
    { label: 'College/University Attended', value: almaMater, hidden: !provider.isSuccessCoachProvider },
    { label: 'Best Part of Success Coaching', value: bestPartSuccessCoach, hidden: !provider.isSuccessCoachProvider },
    { label: 'Tips for Success', value: collegeSuccessTips, hidden: !provider.isSuccessCoachProvider },
  ]

  return rows.filter((i) => !i.hidden)
}
